<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
    />

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검대상</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center"
           v-for="checkbox in form.inspectList"
           v-bind:key="checkbox.id"
      >
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox
            :readonly="board.readonly"
            v-model="checkbox.check"
            @change="checkForm">
          </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    표-->
    <div
      v-for="(inspection, indexRows) in form.inspectList"
      v-bind:key="inspection.id"
    >
      <table-inspect-ep
        class="mt-5"
        v-bind:key="inspection.id"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :is-normal="true"
        :title="inspection.title"
        :list="inspection.list"
        :isNotDotInLabel="true"
        table-header-title="점검항목"
        table-header-yes="양호"
        table-header-normal="보통"
        table-header-no="불량"
        table-header-na="해당없음"
        @update-list-check="(param1, param2)=>{
        updateListCheck(indexRows,param1,param2
        )}"
        v-if="inspection.check"
      />
    </div>

    <!--    현장근로자 의견 청취 및 특이사항-->

    <div class="mt-5">
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 현장근로자 의견 청취 및 특이사항</h5>
        </vs-col>
      </vs-row>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center">
        <div class="label-text mr-4">현장근로자 의견 청취</div>
      </div>
      <div class="col-span-2 flex items-center">
        <p v-if="isPrint" class="print-input">
          {{ form.inputC_1.fileName }}
        </p>
        <file-uploader
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_1"
          class="w-full flex-1"
        />
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center">
        <div class="label-text mr-4">특이사항</div>
      </div>
      <div class="col-span-10 flex items-start">
        <p v-if="isPrint" class="w-full flex-1">{{ form.inputC_2 }}</p>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          :readonly="board.readonly"
          v-model="form.inputC_2"

        />
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'
import FileUploader from '@/components/FileUploader'
import TableInspectEp from '@/components/TableInspectCustomEp'

export default {
  components: {
    TableInspectEp,
    FileUploader,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  methods: {
    checkForm () {
      this.form.typeTitleList = []
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label)
        }
      }
    },
    updateListCheck (indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].is_checked = text
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inputC_1: {},
        inputC_2: '',

        typeTitleList: [],
        inspectList: [],
        photoList: [],
        fileList: [],
      },
    };
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '보호구',
          check: false,
          title: '보호구',
          list: [
            {
              id: 1,
              label: "1. 보호구 착용 및 관리상태(청력, 호흡용)가 적절 한가?",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 기타 보호구 착용 및 관리상태가 적절한가?",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 2,
          label: '환기 및 배기장치',
          check: false,
          title: '환기 및 배기장치',
          list: [
            {
              id: 1,
              label: "1. 환기상태 및 환기설비 작동상태는 적절한가?",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 국소 배기장치 상태 및 작동, 관리는 적절한가?",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "3. 밀폐공간 주기적인 점검 및 파악(산소농도, 자연환기, 환기 사용 점검 등)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 3,
          label: '표지',
          check: false,
          title: '표지',
          list: [
            {
              id: 1,
              label: "1. 안전보건표지는 적절히 부착되어 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 산업안전보건법령요지는 눈에 띄는 곳에 게시되 어 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "3. 화학물질 취급시 MSDS 게시 및 부착의무, 작업 공정별 관리요령 게시가 이루어져 있는가?",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 4,
          label: '작업자세',
          check: false,
          title: '작업자세',
          list: [
            {
              id: 1,
              label: "1. 작업자세/동선 및 중량물 취급자세 (중량물 취급시 2인 1조 작업/ 이동보조도구 활 용 등)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 5,
          label: '작업장',
          check: false,
          title: '작업장',
          list: [
            {
              id: 1,
              label: "1. 작업장 내 정리정돈, 위생상태/ 소화기 유무, 관리 상태 (통로확보, 분리수거함 등)\n",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 시설물 파손여부, 청소, 점검 등 관리상태",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 6,
          label: '근로자',
          check: false,
          title: '근로자',
          list: [
            {
              id: 1,
              label: "1. 근로자의 부상, 외상 등 조치할 수 있는 응급구급함이 갖추어져 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 근로자의 정기적인 건강진단을 실시하고 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "3. 교대근무 여부",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "4. 근로자의 질병 예방 및 사후관리 방안이 활용되 고 있는가? (휴식시간, 휴게시설, 유연근무제 등)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 7,
          label: '교육',
          check: false,
          title: '교육',
          list: [
            {
              id: 1,
              label: "1. 매달 정기안전보건교육을 실시하고 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 신규 근로자의 경우 안전보건교육을 실시하고 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "3. 근로자의 특별교육 해당일 경우 이를 실시하고 있는가?",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 8,
          label: '직업성 질환',
          check: false,
          title: '직업성 질환',
          list: [
            {
              id: 1,
              label: "1. 하루 4시간 이상 집중적으로 자료입력 등을 위한 키보드/마우스 조작작업에 해당이 되는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 하루 총 2시간 이상 쪼그리고 앉거나 무릎을 굽힌 자세의 작업에 해당이 되는가?\n",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "3. 하루 총 2시간 이상 4.5kg이상의 물건을 한 손으 로 들거나 동일한 힘으로 쥐는 작업에 해당이 되는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "4. 5kg이상 중량물 취급 시 중량물 취급안내표시가 부착되어있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "5. 근무시 기타 질환 유발요인들이 있는가?",
              is_checked: "",
              note: ''
            },
          ],
        },
      ]
    }
  },
};
</script>

<style scoped lang="scss">
</style>
